import React, { useEffect, useState } from "react";
import Layout from "../Components/layout/Layout";
import { Link } from "react-router-dom";
import BASE_URL from "../Components/auth/Baseurl";
import axios from "axios";

const Permission = () => {
    const [blog, setBlog] = useState([]);

    const blogData = async () => {
      const response = await axios.get(`${BASE_URL}/blog`, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${localStorage.getItem("token")}`,
        },
      });
      setBlog(response.data.data);
    };
  
    useEffect(() => {
      blogData();
    }, []);
  
    console.log(blog, "dahs");

  return (
    <Layout>
      <div style={{marginTop:"60px"}} className="content">
        <section id="sec1" data-scrollax-parent="true">
          <div className="container">
            <div className="section-title">
              <h2>Agreements</h2>

              <span className="section-separator" />
              <p style={{ fontSize: "15px",textAlign:"center" }}>Let’s Agreements about it!</p>
            </div>
            {/*about-wrap */}
            <div className="about-wrap">
              <div
                style={{ display: "flex", flexWrap: "wrap" }}
                className="row"
              >
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Fly-Ins</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <Link to={"/the-most-fun-fly-ins-in-america"}>
                      <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                        The Most Fun Fly-Ins in America
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Air Shows</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <Link to={"/most-popular-air-shows-in-the-united-states"}>
                      {" "}
                      <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                        11 Most Popular Air Shows in the United States{" "}
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Air Parks</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <Link to={"/airpark-communities-in-the-usa"}>
                      <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                        4 of the Grooviest Airpark Communities in the USA!
                      </p>{" "}
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Aviation Homes</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <Link to={"/innovative-ideas-for-a-hangar-home"}>
                      <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                        Innovative Ideas for a Hangar Home
                      </p>
                    </Link>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Travel</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <Link to={"/ultimate-travel-packing-list-for-ladies"}>
                      {" "}
                      <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                        Ultimate Travel Packing List For Ladies
                      </p>
                    </Link>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Packing List for Pilots
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Pack List for Parents of Young Children
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Pack List for Pet Parents
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Airplane Camping List
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Pilot Flight Bag List
                    </p>
                  </div>
                </div>
                <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Travel Tips</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Packing List for Gentlemen
                    </p>
                  </div>
                </div>
                {blog?.map((e) => (
                  <div className="col-md-3">
                    <div className="ab_text">
                      <div className="ab_text-title fl-wrap">
                        <h3>{e?.heading}</h3>

                        <span className="section-separator fl-sec-sep" />
                      </div>
                      <Link
                        to={"/most-popular-air-shows-in-the-united-states"}
                        state={{ data: e }}
                      >
                        <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>{e?.sub_heading}</p>
                      </Link>

                      {/* <p style={{fontSize:"15px"}}>
                  <div dangerouslySetInnerHTML={{ __html: e?.description }} />
                  </p> */}
                    </div>
                  </div>
                ))}
                {/* <div className="col-md-3">
                  <div className="ab_text">
                    <div className="ab_text-title fl-wrap">
                      <h3>Safety</h3>

                      <span className="section-separator fl-sec-sep" />
                    </div>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Packing List For Ladies
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Packing List for Pilots
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Pack List for Parents of Young Childrens
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Travel Pack List for Pet Parents
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Airplane Camping List
                    </p>
                    <p style={{ fontSize: "15px" ,textDecoration:"underline",color:"black"}}>
                      Ultimate Pilot Flight Bag List
                    </p>
                  </div>
                </div> */}
              </div>
            </div>
            {/* about-wrap end  */}
          </div>
        </section>
      </div>
    </Layout>
  );
};

export default Permission;
